import type { FunctionTestWidgetConfig } from '../function-test.model';

export { FUNCTION_TEST_QUADRATIC_PRESET } from './quadratic.preset';
export { FUNCTION_TEST_SINE_PRESET } from './sine.preset';
export { FUNCTION_TEST_CIRCLE_PRESET } from './circle.preset';
export { FUNCTION_TEST_HLT_QUADRATIC_PRESET } from './hlt-quadratic.preset';

import { FUNCTION_TEST_QUADRATIC_PRESET } from './quadratic.preset';
import { FUNCTION_TEST_SINE_PRESET } from './sine.preset';
import { FUNCTION_TEST_CIRCLE_PRESET } from './circle.preset';
import { FUNCTION_TEST_HLT_QUADRATIC_PRESET } from './hlt-quadratic.preset';

export const FUNCTION_TEST_PRESETS: FunctionTestWidgetConfig[] = [
  FUNCTION_TEST_QUADRATIC_PRESET,
  FUNCTION_TEST_SINE_PRESET,
  FUNCTION_TEST_CIRCLE_PRESET,
  FUNCTION_TEST_HLT_QUADRATIC_PRESET,
];
